module.exports = __webpack_public_path__ + "static/media/videoGameBackground.de07e56d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/videoGameBackground.jpg
// module id = 381
// module chunks = 0